import type { ReactNode } from "react";

import { CUSTOM_FORMATION } from "@legacy-manager/engine";

import { faixasDaEscalacao, nomeCurto } from "./EscalacaoNoCampo";
import { useT } from "../i18n";
import "./tatica.css";

/**
 * O time de outro clube num campo pequeno: onze bolinhas nas cores dele, com
 * a nota de cada um na vaga. O ataque vem de cima para baixo, na direção do
 * gol de quem está olhando.
 */
export function MiniCampo({
  formacao,
  vagas,
  titulares,
  cores,
  className,
}: {
  formacao: string;
  vagas: string[];
  titulares: Array<{ name: string; rating: number }>;
  cores: [string, string];
  className?: string;
}): ReactNode {
  const t = useT();
  const linhas = faixasDaEscalacao(formacao, vagas);
  return (
    <div className={`tatica-mini-campo${className ? ` ${className}` : ""}`}>
      {linhas.map((linha) => {
        const y = 8 + (1 - linha.v) * 84;
        return linha.vagas.map((vaga, ordem) => {
          const x = linha.vagas.length === 1 ? 50 : 14 + (72 * ordem) / (linha.vagas.length - 1);
          const jogador = titulares[vaga.indice];
          return (
            <span key={vaga.indice} className="tatica-adv-jog" style={{ left: `${String(x)}%`, top: `${String(y)}%` }}>
              <span className="tatica-ponto" style={{ background: cores[0], borderColor: cores[1] }}>
                {jogador?.rating ?? ""}
              </span>
              <span className="tatica-ponto-nome">{jogador ? nomeCurto(jogador.name) : ""}</span>
            </span>
          );
        });
      })}
      <span className="tatica-mini-form">{formacao === CUSTOM_FORMATION ? t("tatica.personalizada") : formacao}</span>
    </div>
  );
}
